<section class="top-bar-section">
    <div class="container px-1">
        <div class="mobile-top-bar">
            <div class="d-flex justify-content-center">
                <ul class="toggle-project">
                    <li *ngFor="let m of menuLeft">
                        <a
                          [class.active]="setActive(m.menuName)"
                          (click)="setEnvironment(m)"
                        >
                          {{ m.name }}
                        </a>
                    </li>
                </ul>
            </div>
            <div class="mobile-top-right-menu">
                <span dropdown>
                    <a href id="basic-link" class="mobile-account-toggle" dropdownToggle (click)="false" aria-controls="basic-link-dropdown">
                       <span class="mohawak-icon user-icon user-icon-txt" [attr.aria-label]="'Account initials ' + logo">
                        {{ logo }}
                        
                        <!-- <i class="bi bi-arrow-down-square-fill color-white"></i> -->
                    </span>
                    </a>
                    <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu mobile-sub-header"
                        role="menu" aria-labelledby="basic-link">
                        <li *ngFor="let m of menuRight; let i = index">
                            <span class="is-icon" *ngIf="m?.icon == true">{{ logo }}</span>
                            <a>
                              <label *ngIf="i === 1">&nbsp;Account</label>
                              &nbsp; {{ m.name }}
                            </a>
                        </li>
                        <li
                            class="mobile-exit-item"
                            *ngIf="
                                (isSalesPerson && currentUserInfo?.orgUnit?.inHouseAccount == false) ||
                                (isSalesOps &&
                                currentUserInfo?.orgUnit?.inHouseAccount == false &&
                                currentUserInfo?.orgUnit?.uid !== 'EMPTY_B2BUNIT')
                            "
                        >
                            <a
                                class="mobile-exit-btn"
                                role="button"
                                tabindex="0"
                                (click)="exitClick();"
                                (keydown.enter)="exitClick();"
                            >
                                Exit <i class="bi-chevron-right"></i>
                            </a>
                        </li>
                    </ul>
                  </span>
                  <div class="top-mobile-user">
                    <div class="me-2" style="cursor:pointer">
                        <div class="btn-group" dropdown>
                            <img
                                src="/assets/images/icons/user1.svg"
                                id="button-basic"
                                dropdownToggle
                                type="button"
                                aria-controls="dropdown-basic"
                            />
                            <ul
                                id="dropdown-basic"
                                *dropdownMenu
                                class="dropdown-menu"
                                role="menu"
                                aria-labelledby="button-basic"
                            >
                                @for (item of accountDropdownItems; track item) {
                                    <li role="menuitem" *ngIf="!item.divider">
                                        <a class="dropdown-item" *ngIf="item.path" [routerLink]="item.path">
                                        {{ item.name }}
                                        </a>
                                        <a
                                        class="dropdown-item"
                                        *ngIf="item.pageUrl"
                                        [href]="item.url"
                                        target="_blank"
                                        >
                                        {{ item.name }}
                                        </a>
                                        <a class="dropdown-item" *ngIf="item.logout" (click)="logout()">
                                        {{ item.name }}
                                        </a>
                                        <a class="dropdown-item" *ngIf="item.popup">
                                        {{ item.name }}
                                        </a>
                                        <a class="dropdown-item" *ngIf="item.accounts">
                                        {{ item.name }}
                                        </a>
                                    </li>
                                    <li *ngIf="item.divider" class="divider dropdown-divider"></li>
                                    <li *ngIf="item.salesDivider" class="divider dropdown-divider"></li>
                                }
                            </ul>
                        </div>
                        <div class="btn-group">
                            <div class="cart-icon" (click)="navigateToCart()"
                        style="cursor:pointer">
                        <img src="/assets/images/icons/cart.svg">
                        <div class="cart-icon__count">
                            {{ cartCount }}
                          </div>
                    </div>
                        </div>
                    </div>
                  </div>
                  
                
            </div>
        </div>
        <div class="top-bar">
            <ul class="top-bar-menu-left">
                <li *ngFor="let m of menuLeft">
                    <a
                      [routerLink]="'/' + m.link"
                      [class.active]="setActive(m.menuName)"
                      (click)="setEnvironment(m)"
                    >
                      {{ m.name }}
                    </a>
                </li>
                <li *ngIf="isBuilderXchnage === true">
                    <a href="https://staging-crest.mohawkbuilder.com/" target="_blank"
                      >Builder Xchange</a
                    >
                </li>
            </ul>
            <ul class="top-bar-menu-right">
                <li *ngFor="let m of menuRight; let i = index">
                    <span class="is-icon" *ngIf="m?.icon == true">{{ logo }}</span>
                    <a>
                      <label *ngIf="i === 1">Account</label>
                      <span>{{ m.name }}</span>
                      <button
                        class="change-btn"
                        *ngIf="
                            (i + 1 === menuRight.length &&
                            isSalesPerson &&
                            currentUserInfo?.orgUnit?.inHouseAccount == false) ||
                            (i + 1 === menuRight.length &&
                            isSalesOps &&
                            currentUserInfo?.orgUnit?.inHouseAccount == false &&
                            currentUserInfo?.orgUnit?.uid !== 'EMPTY_B2BUNIT')
                        "
                        (click)="exitClick();"
                        >
                        Exit <i class="bi-chevron-right"></i>
                        </button>
                      
                      
                    </a>
                </li>
            </ul>
        </div>
    </div>
</section>

<header class="header-section">
    <div class="container px-0">
        <header class="site-header">
            <div class="site-logo-and-search-container">
                <!-- <div class="hambergur-menu" (click)="showMenu()"><img src="/assets/images/icons/hambergur-menu.svg"></div> -->
                <div class="logo" style="cursor:pointer" [routerLink]="getLogoRouterLink()">
                    <img src="/assets/images/mohawk-dark-logo.svg" alt="">
                </div>
            </div>
           <!--  <div class="products-search" *ngIf=" accountInfoSet &&
              storageService.userInfo?.orgUnit?.accountType != 'ZMSH'"
            >
                <xchange-search-control
                    placeholder="Search Products"
                    title="Please fill out this field."
                ></xchange-search-control>
            </div> -->
            <div class="site-header-cart-container">
                <div class="user-role me-3"><label>Role: </label> {{salesManRole}}</div>
                <div class="cart-content me-2" *ngIf="
                        (isSalesPerson &&
                        currentUserInfo?.orgUnit?.inHouseAccount == false) ||
                        (isSalesOps &&
                        currentUserInfo?.orgUnit?.inHouseAccount == false &&
                        currentUserInfo?.orgUnit?.uid !== 'EMPTY_B2BUNIT')
                    ">
                    <button class="btn btn-secondary account-btn" (click)="exitClick('view-accounts')">
                        Return to accounts
                    </button>
                    <button class="account-btn-mobile" captureClicks  routerLink="/residential/salesperson/view-accounts">
                        <img src="/assets/images/icons/cart.svg">
                    </button>
                </div>
                <div class="d-flex top-mobile-hide-user">
                    <div class="me-2" style="cursor:pointer">
                        <div class="btn-group" dropdown>
                            <img
                                src="/assets/images/icons/user1.svg"
                                id="button-basic"
                                dropdownToggle
                                type="button"
                                aria-controls="dropdown-basic"
                            />
                            <ul
                                id="dropdown-basic"
                                *dropdownMenu
                                class="dropdown-menu"
                                role="menu"
                                aria-labelledby="button-basic"
                            >
                                @for (item of accountDropdownItems; track item) {
                                    <li role="menuitem" *ngIf="!item.divider">
                                        <ng-container *ngIf="item.name === 'Sales Dashboard'">
                                            <a class="dropdown-item" (click)="salesDashboardClick()">
                                            {{ item.name }}
                                            </a>
                                        </ng-container>
                                        <ng-container *ngIf="item.name !== 'Sales Dashboard'">
                                            <a class="dropdown-item" *ngIf="item.path" [routerLink]="item.path">
                                            {{ item.name }}
                                            </a>
                                            <a
                                            class="dropdown-item"
                                            *ngIf="item.pageUrl"
                                            [href]="item.url"
                                            target="_blank"
                                            >
                                            {{ item.name }}
                                            </a>
                                            <a class="dropdown-item" *ngIf="item.logout" (click)="logout()">
                                            {{ item.name }}
                                            </a>
                                            <a class="dropdown-item" *ngIf="item.popup">
                                            {{ item.name }}
                                            </a>
                                            <a class="dropdown-item" *ngIf="item.accounts">
                                            {{ item.name }}
                                            </a>
                                        </ng-container>
                                    </li>
                                    <li *ngIf="item.divider" class="divider dropdown-divider"></li>
                                    <li *ngIf="item.salesDivider" class="divider dropdown-divider"></li>
                                }
                            </ul>
                        </div>
                    </div>
                    <div class="cart-icon" (click)="navigateToCart()"
                        style="cursor:pointer">
                        <img src="/assets/images/icons/cart.svg">
                        <div class="cart-icon__count">
                            {{ cartCount }}
                          </div>
                    </div>
                </div>
                
            </div>
        </header>
    </div>
</header>